import { NgClass } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputSwitchModule } from 'primeng/inputswitch';
import { CommonBindingDataService } from '../../../services/common-binding-data.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-toggle-button',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, InputSwitchModule, NgClass],
  templateUrl: './toggle-button.component.html',
  styleUrl: './toggle-button.component.scss'
})
export class ToggleButtonComponent implements OnInit, OnDestroy {
  @Input() field: any;
  formName: FormGroup;
  @Input() attributeLabels: [];
  @Input() moduleName: string;
  showToggleComponent = true;
  label: any;
  placeholder: any;
  userRoleSubscription: Subscription;

  constructor(private formGroupDirective: FormGroupDirective,
    public cs: CommonBindingDataService) {
    this.formName = this.formGroupDirective.control;
  }

  ngOnInit(): void {
    this.label = this.cs.getLabelValue(`${this.moduleName}.fields.${this.field.attributeCode}.label`,this.attributeLabels,'');
    this.placeholder = this.cs.getLabelValue(`${this.moduleName}.fields.${this.field.attributeCode}.placeholder`,this.attributeLabels,'');
    if(this.field.attributeCode === 'can_order') {
      this.userRoleSubscription = this.cs.userRole$.subscribe(event => {
        if(event === 'Site Pharmacist') {
          this.showToggleComponent = true;
          this.formName.controls[this.field.attributeCode].setValue(this.formName.value[this.field.attributeCode]);
          this.formName.controls[this.field.attributeCode].updateValueAndValidity();
        } else {
          this.showToggleComponent = false;
          this.formName.controls[this.field.attributeCode].setValue(false);
          this.formName.controls[this.field.attributeCode].updateValueAndValidity();
        }
      })
    }
  }

  ngOnDestroy(): void {
    if(this.userRoleSubscription) {
      this.userRoleSubscription.unsubscribe();
    }
  }
}
